import { computed } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { areButtonStatesEqual, BUTTON_INITIAL_STATE } from './cost-to-build-client-ui-button.state';
import type { ButtonState } from './cost-to-build-client-ui-button.types';

export const ButtonStore = signalStore(
    withState(BUTTON_INITIAL_STATE),
    withComputed((store) => ({
        isDisabled: computed(() => store.disabled() || store.loading()),
        state: computed<ButtonState>(() => ({
            ariaLabel: store.ariaLabel(),
            clickCount: store.clickCount(),
            disabled: store.disabled(),
            id: store.id(),
            label: store.label(),
            loading: store.loading(),
            size: store.size(),
            type: store.type(),
            variant: store.variant(),
        })),
    })),
    withMethods((store) => {
        const setState = (patch: Partial<ButtonState>) => {
            const nextState: ButtonState = {
                ...store.state(),
                ...patch,
            };

            if (areButtonStatesEqual(store.state(), nextState)) {
                return;
            }

            patchState(store, patch);
        };

        return {
            registerClick() {
                setState({ clickCount: store.clickCount() + 1 });
            },
            reset() {
                setState(BUTTON_INITIAL_STATE);
            },
            setLabel(label: string) {
                setState({ label });
            },
            setLoading(loading: boolean) {
                setState({ loading });
            },
            setState,
        };
    })
);
